module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#astrology",
      toString: function () {
        return this.url;
      }
    }